import { Edge, Node } from "reactflow";
import { ITopicPair } from "src/app/nlp/~store/models/TopicPair";
import {
    DEFAULT_EDGE_PROPS,
    DEFAULT_NODE_PROPS,
} from "../constants/defaultValues";
import { ButtonsNodeData } from "../models/buttonsNode";
import { TopicPairsTree } from "../models/common";
import {
    extractAllButtonsValuesFromTopicPair,
    extractAllTopicPairNextTriggers,
} from "./graphDataCreation";

export const makeNode = (
    id: string,
    pair: ITopicPair,
    isFirst = false
): Node<ButtonsNodeData> => {
    return {
        ...DEFAULT_NODE_PROPS,
        id,
        data: {
            isFirst,
            buttons:
                pair.answer?.buttons.map((button, buttonIndex) => ({
                    label: button.name,
                    outputId: `output-${buttonIndex}-${id}`,
                    targetTriggerName: button.value,
                    buttonType: button.type,
                })) ?? [],
            label: pair.triggerName,
            topicPairId: pair.topicPairId,
            nextAlgo: (pair.answer?.parametersJson as any)?.NextAlgo,
            triggerName: pair.triggerName,
            subject: pair.subject,
            nextTriggers: extractAllTopicPairNextTriggers(pair),
        },
    };
};

export const makeEdge = (
    parentId: string,
    childId: string,
    sourceHandle?: string
): Edge => {
    return {
        ...DEFAULT_EDGE_PROPS,
        id: `${parentId}-${childId}`,
        source: parentId,
        target: childId,
        sourceHandle,
    };
};

export const makeNodes = (tree?: TopicPairsTree): Node<ButtonsNodeData>[] => {
    let isFirst = true;
    const nodes: Node<ButtonsNodeData>[] = [];

    const traverse = (tree?: TopicPairsTree) => {
        const id = tree?.id;
        const pair = tree?.pair;
        if (id && pair) {
            nodes.push(makeNode(id, pair, isFirst));
            isFirst = false;
        }
        tree?.children.forEach((child) => {
            traverse(child);
        });
    };

    traverse(tree);

    return nodes;
};

export const makeEdges = (tree?: TopicPairsTree): Edge[] => {
    const edges: Edge[] = [];

    const traverse = (tree?: TopicPairsTree) => {
        if (!tree?.pair || !tree?.id) return;
        const parentId = tree.id;
        const triggerNames = extractAllButtonsValuesFromTopicPair(tree.pair);
        const nextTriggers = extractAllTopicPairNextTriggers(tree.pair);

        if (parentId) {
            tree?.children.forEach((child) => {
                nextTriggers.forEach((nextTrigger) => {
                    if (child.pair.triggerName === nextTrigger) {
                        edges.push(makeEdge(parentId, child.id));
                    }
                });

                if (triggerNames.length) {
                    const buttonIndex = triggerNames.findIndex(
                        (name) => name === child.pair.triggerName
                    );

                    if (buttonIndex !== -1) {
                        edges.push(
                            makeEdge(
                                parentId,
                                child.id,
                                `output-${buttonIndex}-${parentId}`
                            )
                        );
                    }
                }

                traverse(child);
            });
        }
    };

    traverse(tree);

    return edges;
};
